import Countdown from "@/theme2/components/promotion/Countdown";

export default function FlashDealsCountdown({ targetDate }) {
  return (
    <div
      className="w-full max-w-xl"
      aria-label="Flash deal countdown timer"
    >
      <Countdown targetDate={targetDate} />
    </div>
  );
}